// extracted by mini-css-extract-plugin
export default {"chat-drawer":"styles_chat-drawer__uQajm","chat-drawer-open":"styles_chat-drawer-open__lArGD","chat-header":"styles_chat-header__PRoXB"};